import * as Yup from 'yup';

export default () =>
  Yup.object({
    directDebitDate: Yup.date()
      .min(new Date(), "La date doit être supérieure à aujourd'hui")
      .required('Date de transfert requise !'),
  });
